export enum RosterStatus {
  optimising = 'Optimising',
  published = 'Published',
  republished = 'Republished',
  draft = 'Draft',
  editing = 'Editing'
}
